<template>
    <div>
        <div v-click-outside="hide">
            <button @click="load" class="btn dropdown-toggle rounded-pill bg-white">
                <img width="12" height="16" :src="pinIconUrl" alt="pin-icon"/>
                <span class="ml-1 mr-2" id="user_location_short">{{ trimmedLocation }}</span>
            </button>
        </div>

        <div v-if="opened" class="dropdown-container p-4">
            <div class="row mx-md-4">
                <div class="col-12 col-md-6">
                    <form method="get" :action="formAction" autocomplete="off">
                        <input @click="openCityList" v-model="searchQuery"
                               id="citySelector" name="location" class="form-control dropdown-input"
                               type="text" placeholder="Search by City" autocomplete="off">
                        <div class="city-option" v-show="display">
                            <a v-for="(city, key) in resultQuery" :data-id="key"
                               :href="'/location/set/' + city.plInitials + '/' + city.plName"
                               class="city-list">
                                {{ city.plName }}
                            </a>
                        </div>
                    </form>
                </div>
                <div class="col-12 col-md-6 ml-2 ml-md-0 pt-3 pt-md-1">
                    <a :href="determineLocationRoute" class="cities">
                        <font-awesome-icon icon="location-arrow"/>
                        <span class="pl-2">Determine Location</span>
                    </a>
                </div>
            </div>
            <hr class="filter-divider">
            <section @click="closeCityList">
                <!-- List Cities -->
                <city-filter
                    :location="location"
                    :province="province"
                    :locationsAlphabetical="locationsAlphabetical"
                    :locationsCloseBy="locationsCloseBy"
                    :locationsMostPopular="locationsMostPopular"
                    :provinceName="provinceName">
                </city-filter>
            </section>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import CityFilter from "./CityFilter";
import ClickOutside from 'vue-click-outside';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faLocationArrow} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

library.add(faLocationArrow);

Vue.component('font-awesome-icon', FontAwesomeIcon);
export default {
    name: "LocationSelect",
    components: {
        CityFilter
    },
    props: {
        pinIconUrl: String,
        trimmedLocation: String,
        location: String,
        province: String,
        provinceName: String,
        determineLocationRoute: String,
        formAction: String,
    },
    data() {
        return {
            searchQuery: null,
            opened: false,
            display: false,
            loaded: false,
            locationsAlphabetical: [],
            locationsCloseBy: [],
            locationsMostPopular: [],
        }
    },
    methods: {
        closeCityList: function () {
            this.display = false
        },
        openCityList: function () {
            this.display = true
        },
        load: function () {
            this.closeCityList()
            if (!this.opened) {
                this.opened = true
            } else {
                this.opened = false
            }
            if (!this.loaded) {
                axios.all([
                    // GET request using axios with set headers
                    //const headers = {"X-Authorization": :"key" };

                    //locations - alphabetical
                    axios.get("/filter", {
                        params: {
                            "filter": "alphabetical",
                            "province": this.province
                        }
                    }),
                    //locations - close to me
                    axios.get("/filter", {
                        params: {
                            "filter": "close",
                            "city": this.location
                        }
                    }),
                    //locations - most popular
                    axios.get("/filter",{
                        params: {
                            "platform": "web",
                        }
                    }),


                ]).then(axios.spread((alphabetical, close, popular) => {
                    this.locationsAlphabetical = alphabetical.data;
                    this.locationsCloseBy = close.data;
                    this.locationsMostPopular = popular.data;
                    this.loaded = true;
                }));
            }
        },

        hide() {
            this.opened = false
        },
    },
    computed: {
        resultQuery() {
            if (this.searchQuery) {
                return this.locationsAlphabetical.filter((city) => {
                    return this.searchQuery.toLowerCase().split(' ').every(v => city.plName.toLowerCase().includes(v));
                })
            } else {
                return this.locationsAlphabetical;
            }
        }
    },

    mounted() {
        this.popupItem = this.$el
    },
    directives: {
        ClickOutside
    }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

button {
    height: 2rem;
}

img {
    height: 1rem;
}

.dropdown-container {
    position: absolute;
    top: 2.5rem;
    left: 0;
    right: -8.5rem;
    z-index: 9;
    text-align: left;
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 1rem;
    transform: translate3d(0, 0, 0);
}

@media only screen and (min-width: 576px) {
    .dropdown-container {
        right: -15rem;
    }
}

@media only screen and (min-width: 768px) {
    .dropdown-container {
        right: -20rem;
    }
}

@media only screen and (min-width: 992px) {
    .dropdown-container {
        right: -30rem;
    }
}

@media only screen and (min-width: 1200px) {
    .dropdown-container {
        right: -30rem;
    }
}

#citySelector {
    background-image: url(https://leafyimages.s3.ca-central-1.amazonaws.com/images/assets/LocationPin-17.png);
    background-repeat: no-repeat;
    background-position: 0.5rem center;
    background-size: 1rem;
    text-indent: 1.5rem;
    border-radius: 2rem;
}

.city-option {
    position: absolute;
    border: 1px solid #ddd;
    overflow: auto;
    overflow-x: hidden;
    max-height: 25rem;
    max-width: 15rem;
    background-color: white;
    z-index: 1;
}

.city-list {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}

.city-list:hover {
    background-color: lightgray;
    text-decoration: none;
}

.cities {
    color: black;
    text-decoration: none;
}

.cities:hover {
    text-decoration: none;
    color: #FF7546;
}

.filter-divider {
    border-top: 3px solid $primary;
    width: 90%;
    margin-top: 1.25rem;
}
</style>
